import { useMutation, useQueryClient } from '@tanstack/react-query';
import { createProductWithVariants } from '../../api/apiProducts';
import { toast } from 'react-hot-toast';
import parseError from '../../utils/parseError';

/**
 * Hook to create a new product with variants in a single request
 */
export const useCreateProductWithVariants = () => {
    const queryClient = useQueryClient();

    const { mutate: createProductWithVariantsMutate, isPending: isCreating } = useMutation({
        mutationFn: createProductWithVariants,
        onSuccess: (res) => {
            queryClient.invalidateQueries({ queryKey: ['products'] });
            toast.success(res?.data?.message || res?.message || 'Product created successfully');
        },
        onError: (error) => {
            const message = parseError(error);
            toast.error(message);
        }
    });

    return { createProductWithVariantsMutate, isCreating };
};
